import { Box } from "@mui/material";
import {  useState } from "react";
import { useGlobalAuthContext } from "../context/AuthContext";
import ProductsTable from "../Components/Products/ProductsTable";
import { useProductsQuery } from "../Slices/roomNateApis";
import { useGlobalContext } from "../context/GlobalContext";

const Products = () => {
  const {activePartner} = useGlobalContext();
  
  const { currentUserSessionStorage } = useGlobalAuthContext();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [user, setUser] = useState(null);



  const { data: productsData } = useProductsQuery({partner: activePartner, user: user?.value, startDate, endDate}, {
    skip: !currentUserSessionStorage,
  });


  return (
    <Box>
      <ProductsTable
        productsData={productsData}
        user={user}
        setUser={setUser}
        startDate={startDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        endDate={endDate}
      
      />

    </Box>
  );
};

export default Products;
